export const CREATE = 'CREATE';
export const DELETE = 'DELETE';
export const UPDATE_ASSET = 'UPDATE_ASSET';
export const DELETE_ASSET = 'DELETE_ASSET';
export const RESET_ASSET = 'RESET_ASSET';
export const UPDATE_ANATOMY = 'UPDATE_ANATOMY';
export const UPDATE_GENDER = 'UPDATE_GENDER';
export const UPDATE_SKIN = 'UPDATE_SKIN';
